/* istanbul ignore file */
import moment from 'moment';
import { useFieldHelper, LinkField, FieldProps } from 'framework/ui/field';
import { DATE_FORMAT, updateCurrencyName } from 'framework/utils';
import { useLedgerUrl } from './route';

const LedgerLink = ({
  source,
  nameSource,
  dateSource,
  ...props
}: FieldProps & { nameSource: string; dateSource?: string }) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getValue: getDate } = useFieldHelper({ source: dateSource });
  const { getSingleEntityUrl } = useLedgerUrl();
  const id = getValue()?.replace(/[/]/g, '_');
  const name = updateCurrencyName((getName() || getValue() || '').replace(/[/]/g, ' / '));
  const date = getDate();
  let filter = '';

  if (date) {
    const dateMonthStart = moment(date).startOf('month').format(DATE_FORMAT.API_ONLY_DATE);
    const dateMonthEnd = moment(date).endOf('month').format(DATE_FORMAT.API_ONLY_DATE);

    filter = `?filter={"period":{"ge":"${dateMonthStart}","le":"${dateMonthEnd}"}}`;
  }

  return <LinkField linkText={name} isInternal value={id ? `${getSingleEntityUrl(id)}${filter}` : null} {...props} />;
};

export default LedgerLink;
